import { put, select, takeLeading } from 'redux-saga/effects';
import { commonActions } from '../../common';
import { playTourSelectors } from '../../playTour';

const clearCompletedOfflineTours = takeLeading(
  commonActions.initApp.type,
  function* () {
    const completedTourShortLinks = playTourSelectors.selectCompletedTourShortLinks(yield select());

    for (let i = 0; i < completedTourShortLinks.length; i++) {
      yield put(commonActions.removeTour(completedTourShortLinks[i]));
    }
  }
);

const sagas = [clearCompletedOfflineTours];

export default sagas;
